import { ILocation, IServerEvent } from "../interfaces/map.interfaces";

export const getNewestCrownClosureEvent = (
  events: IServerEvent[] | undefined
): IServerEvent | null => {
  if (!events?.length) return null;
  const sorted = [...events].sort(
    (a, b) =>
      new Date(b.properties.date).getTime() -
      new Date(a.properties.date).getTime()
  );
  return sorted[0];
};

export const toCrownClosurePathLocations = (
  locations: ILocation[]
): ILocation[] =>
  (locations || []).map((location) => {
    const newest = getNewestCrownClosureEvent(location.events);
    return {
      ...location,
      events: newest ? [newest] : [],
    };
  });

export const transformCrownClosureData = (data: any[]) =>
    (data || []).flatMap((item) =>
      (item.events || []).map((event: any) => {
        const { geojson, state, ...restProps } = event.properties || {};
  
        // Clean original event
        const ogData = {
          ...event,
          properties: {
            ...restProps,
            state,         // keep it here too
          },
        };
  
        // Build a FeatureCollection where every feature has state injected
        const separatedGeojson = {
          type: "FeatureCollection" as const,
          features: (geojson?.features || []).map((feature: any) => {
            const f = {
              ...feature,
              properties: {
                ...feature.properties,
                state,     // ← inject here!
              },
            };
            // debug log each feature’s properties

            return f;
          }),
        };
  
        return { ogData, separatedGeojson };
      })
    );
  